// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2L2Li","delete":"styles_delete__3TvM7","update":"styles_update__3mLQJ","add":"styles_add__2taLr"};